module.exports = __webpack_public_path__ + "img/square-red.81568827.svg";